import React from "react";
import {
  Area,
  AreaChart,
  Cell,
  Line,
  LineChart,
  Pie,
  PieChart,
  RadialBar,
  RadialBarChart,
  ResponsiveContainer,
  Tooltip,
} from "recharts";
import CircularProgress from "./CircularProgress";

export default function SparkLine({ data, unit = "", percentage = null }) {
  return (
    <div style={{ height: 80, overflow: "visible" }}>
      <ResponsiveContainer className="relative overflow-visible" height="100%">
        {percentage == null ? (
          <AreaChart data={data}>
            <defs>
              <linearGradient id="fill" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#8884d8" stopOpacity={0.3} />
                <stop offset="95%" stopColor="#8884d8" stopOpacity={0} />
              </linearGradient>
            </defs>
            <Tooltip
              content={<CustomTooltip unit={unit} />}
              wrapperStyle={{
                zIndex: 9999,
                pointerEvents: "none",
                transform: "translateY(-120%)" 
              }}
              position={undefined} 
              // position={{ y: -10 }} // push above chart
              offset={20} // 👈 controls distance from cursor
              cursor={{
                stroke: "#8884d8",
                strokeWidth: 1,
                strokeDasharray: "3 3",
              }}
            />
            <Area
              type="monotone"
              dataKey="value"
              stroke="#8884d8"
              strokeWidth={3}
              fill="url(#fill)"
              // fill="url(#fillGradient)"
              //  dot={false}
              dot={{ r: 0, fill: "#8884d8" }}
              activeDot={{ r: 8 }}
              isAnimationActive={true}
            />
          </AreaChart>
        ) : (
          <CircularProgress
            className=" absolute right-0 top-0 bottom-0  m-auto "
            percentage={percentage}
            size={60}
            strokeWidth={5}
            color="#6C5CE7"
          />
        )}
      </ResponsiveContainer>
    </div>
  );
}

const CustomTooltip = ({ active, payload, unit }) => {
  const formatTime = (ts) => {
    return new Date(ts * 1000).toLocaleString("en-IN", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  if (active && payload && payload.length) {
    const point = payload[0].payload;

    return (
      <div
        style={{
          background: "#fff",
          border: "1px solid #ddd",
          borderRadius: "10px",
          padding: "10px 14px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          fontSize: "12px",
          whiteSpace: "nowrap",
          pointerEvents: "none",
          transition: "opacity 0.15s ease",
        }}
      >
        <div style={{ fontWeight: 600, marginBottom: 4 }}>
          {formatTime(point.time)}
        </div>
        <div className="text-slate-700 text-xs font-normal">
          Usage:
          <span className="font-bold">
            {unit === "%"
              ? `${payload[0].value} ${unit}`
              : formatBytes(payload[0].value)}
          </span>
        </div>
      </div>
    );
  }

  return null;
};

function formatBytes(bytes) {
  if (bytes < 1024) return bytes + " B";
  else if (bytes < 1024 ** 2) return (bytes / 1024).toFixed(2) + " KB";
  else if (bytes < 1024 ** 3) return (bytes / 1024 ** 2).toFixed(2) + " MB";
  else return (bytes / 1024 ** 3).toFixed(2) + " GB";
}
